__turbopack_context__.v({
  "disabled": "StyledLink-module__ThsEVW__disabled",
  "link": "StyledLink-module__ThsEVW__link",
  "primary": "StyledLink-module__ThsEVW__primary",
  "secondary": "StyledLink-module__ThsEVW__secondary",
});
